<template>
  <keep-alive v-if="!!atopicDermatitisQuestion">
    <component :is="atopicDermatitisQuestion" v-model="modelValue" v-bind="questionData" :disabled="disabled" />
  </keep-alive>
  <div v-else></div>
</template>

<script>
import { Component, ComputedOptions } from 'vue'
import { PropsDefinition, Computed, ModelValueProp } from '@/_typedefs'
import HospitalizationNode from '@/components/NewAttendanceForm/AtopicDermatitis/Questions/HospitalizationNode.vue'

/**
 * @typedef {Object} AtopicDermatitisNodeProps
 * @property {string} title
 * @property {string} kind
 * @property {object} questionData
 */

/** @typedef {AtopicDermatitisNodeProps & ModelValueProp<any>} Props */

export default {
  name: 'AtopicDermatitisQuestionNode',
  /** @type {PropsDefinition<Props>} */
  props: {
    value: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    kind: {
      type: String,
      required: true,
    },
    questionData: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    /** @type {Computed<Component | null>} */
    atopicDermatitisQuestion() {
      const questionMap = {
        'atopic-dermatitis:hospitalization': HospitalizationNode,
      }

      return questionMap[this.kind] ?? null
    },
    /** @type {ComputedOptions<any>} */
    modelValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>

<style></style>
